import styled from '@emotion/styled';

export const HR = styled.hr`
  border-top: 1px solid var(--colors-gray-3);
  border-bottom: 0;
  border-right: 0;
  border-left: 0;
`;
